import { useRef } from 'react';
import { usePhaserGame } from '@/hooks/usePhaserGame';
import { UiRoot } from '@/ui/layout/UiRoot';

export function GameShell() {
  const gameContainerRef = useRef<HTMLDivElement>(null);

  usePhaserGame(gameContainerRef);

  return (
    <main className="relative h-screen w-screen overflow-hidden bg-[#10140b] text-white">
      <div className="absolute inset-0 bg-[linear-gradient(135deg,#10140b_0%,#243a20_48%,#77352f_100%)]" />
      <div className="absolute inset-0 bg-scanlines bg-[length:100%_4px] opacity-[0.14]" />
      <section className="relative z-10 flex h-full w-full items-stretch justify-stretch">
        <div className="relative flex-1">
          <div
            ref={gameContainerRef}
            id="game-root"
            className="absolute inset-0 overflow-hidden"
          />
        </div>
        <UiRoot />
      </section>
    </main>
  );
}
